const dashboardDataSection = $('#data-section');
const dataCards = dashboardDataSection.find('.data-card-parent');

const dashboardDataCardsAnimation = () => {
    dataCards.each(function () { 
        const cardImage = $(this).find('.data-card-image');
        const cardsWidth = pxToVw(cardImage.outerWidth());
        const cardsGap = isDesktop() ? 0.625 : 1.302;
        const cardImageOffset = cardsWidth + cardsGap;
        gsap.set(cardImage, {
            x: `${cardImageOffset}vw`, 
            scale: 0.99, 
            opacity: 0,
        });
        
        const cardTL = gsap.timeline({paused: true});
        cardTL.add(gsap.to(cardImage, {
            x: 0,
            scale: 1,
            duration: 1,
            ease: 'pageInEasing',
        }), 0);
        cardTL.add(gsap.to(cardImage, {
            opacity: 1,
            duration: 0.83,
            ease: 'opacityInEasing',
        }), 0);

        ScrollTrigger.create({
            trigger: $(this),
            start: 'top center',
            once: true,
            onEnter: () => {
                cardTL.play();
            }
        })
    });
}

const addDashboardDataAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionInTL = gsap.timeline({
    paused: true,
  });

  sectionInTL.add(
    animateSectionTopperIn({
      sectionParent: dashboardDataSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  sectionInTL.add(elementInAnimationYWOpacity(dataCards, '36%', 0, 1, 1, 1, 0, 0.3, 'start', 'pageInEasing', 'pageInEasing').play(), 0);
  /*
  audienceCards.each(function (index) {
    //audienceTL.add(addElementInAnimation($(this), '36%', 1, 0).play(), 0.3 * index);
  });
  */

  return sectionInTL;
};

const dashboardDataTrigger = () => {
    dashboardDataCardsAnimation();
  const dashboardDataTL = addDashboardDataAnimation();
  ScrollTrigger.create({
    trigger: dashboardDataSection,
    start: 'top top+=110%',
    end: 'bottom bottom',
    once: true,
    onUpdate: (self) => {
      dashboardDataTL.progress(self.progress);
    },
  });
}

addSectionObserver(dashboardDataSection, dashboardDataTrigger, false);
